export default __webpack_public_path__ + "static/media/hoichoi-tech-logo.7561653f.png";